import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/e/employee-onboarding')({
  staticData: { hideShell: true },
});
